<template>
	<div class="fitnessplanCreate">
		<VueLoading :active.sync="showLoadingIndicator" :can-cancel="true"></VueLoading>

		<!-- Import from Health / Health Connect (create only) -->
		<template v-if="showImportSection">
			<v-btn @click="openTrackedWorkoutsModal" class="button button--outline button--small button--icon fitnessplanCreate__import">
				<img src="@/assets/ic_16_share.svg" alt="">
				Training importieren
			</v-btn>
			<div class="divider">oder</div>
			<TrackedWorkoutsModal
				v-if="activityDate"
				:realStartDate="activityDate"
				@importWorkout="importWorkout"
				@closeTrackedWorkoutsModal="closeTrackedWorkoutsModal"
			/>
		</template>

		<!-- EXERCISE FILLED -->
		<div v-if="selectedFitnessPlanActivity" class="fitnessplanCreate__exercise">
			<div class="fitnessplanCreate__exercise__item">

				<div v-if="selectedFitnessPlanActivity && activityType == 'workout.WorkoutPage'">
					<WorkoutItem :workout="selectedFitnessPlanActivity" :selectOnly="true"></WorkoutItem>
				</div>
				<div v-else-if="selectedFitnessPlanActivity && activityType == 'exercise.PlaylistPage'">
					<PlaylistItem :playlist="selectedFitnessPlanActivity" :selectOnly="true"></PlaylistItem>
				</div>
				<div v-else-if="selectedFitnessPlanActivity" class="card">
					<div v-if="selectedFitnessPlanActivity.name" class="card__title">{{ selectedFitnessPlanActivity.name }}</div>
					<div v-else-if="selectedFitnessPlanActivity.title" class="card__title">{{ selectedFitnessPlanActivity.title }}</div>
					<div class="card__subtitle">{{ selectedFitnessPlanActivity.subtitle }}</div>
					<img v-if="selectedFitnessPlanActivity.image_url" class="card__image" :src="'https://app.sportlerplus.com/scaled/800/' + selectedFitnessPlanActivity.image_url" alt="" />
                    <img v-else-if="activityType == 'blog.BlogPage'" class="card__image" :src="'https://app.sportlerplus.com/scaled/800/' + selectedFitnessPlanActivity.main_image_url" alt="" />
					<img v-else-if="activityType == 'Custom/UserPlaylist'" class="card__image" src="https://app.sportlerplus.com/scaled/800/bruce-mars-gJtDg6WfMlQ-unsplash.jpg" alt="" >
				</div>

			</div>
			<div v-if="!uniqueChallengeId" class="fitnessplanCreate__exercise__footer" @click="selectActivity">
				<img src="@/assets/ic_16_fitnessplan_change.svg">
				Übung ändern
			</div>
		</div>

		<!-- EXERCISE EMPTY -->
		<div v-else class="fitnessplanCreate__exercise fitnessplanCreate__exercise--empty" @click="selectActivity">
			<img src="@/assets/ic_fitnessplan_add.svg">
			Übung wählen
		</div>

		<!-- SERIENTERMIN: only on create — editing cannot convert series↔single -->
		<div v-if="!editItemId && !relatedFitnessPlanItem && !uniqueChallengeId" class="list list--background">

			<label :class="repeatActivity ? 'list__item is-active' : 'list__item'">
				<div class="list__item__icon">
					<img src="@/assets/ic_24_fitnessplan_serie.svg" alt="" />
				</div>
				<div class="list__item__content">
					<div class="list__item__label">
						Serientermin
					</div>
				</div>
				<div class="toggle">
                    <input type="checkbox" v-model="repeatActivity">
                    <span class="toggle__button"></span>
                </div>
			</label>

			<div v-if="repeatActivity" class="fitnessplanCreate__serie">
				<radio-set v-model="selectedRepeatInterval" label-name="" :options="repeatOptions"/>
			</div>
		</div>

		<!-- Series interval when editing an existing series (checkbox hidden) -->
		<div v-if="editItemId && repeatActivity && !uniqueChallengeId" class="list list--background">
			<div class="fitnessplanCreate__serie" style="padding: 12px 0 0;">
				<radio-set v-model="selectedRepeatInterval" label-name="" :options="repeatOptions"/>
			</div>
		</div>

		<!-- DATE & TIME -->
		<div class="list list--background">

			<!-- DATE -->
			<div v-if="!uniqueChallengeId" class="list__item drilldown">
				<div class="list__item__icon">
					<img src="@/assets/ic_24_fitnessplan_date.svg" alt="" />
				</div>
				<label class="list__item__content">
					<div v-if="!repeatActivity" class="list__item__label">
						Datum
					</div>
					<div v-if="repeatActivity" class="list__item__label">
						Startdatum
					</div>
					<div class="list__item__value list__item__value--light">
						<input type="date" v-model="activityDate">
					</div>
				</label>
			</div>

			<div v-if="repeatActivity" class="list__item drilldown">
				<div class="list__item__icon">
					<img src="@/assets/ic_24_fitnessplan_date.svg" alt="" />
				</div>
				<label class="list__item__content">
					<div class="list__item__label">
						Enddatum
					</div>
					<div class="list__item__value list__item__value--light">
						<input type="date" v-model="activityEndDate">
					</div>
				</label>
			</div>

			<!-- WEEKDAYS (multi-select; hidden for monthly) -->
			<div v-if="repeatActivity && selectedRepeatInterval && selectedRepeatInterval.value !== 2" class="list__item">
				<div class="list__item__icon">
					<img src="@/assets/ic_24_fitnessplan_date.svg" alt="" />
				</div>
				<div class="list__item__content fitnessplanCreate__weekdaysRow">
					<div class="list__item__label">Wochentage</div>
					<div class="fitnessplanCreate__weekdays">
						<button
							v-for="opt in weekdayOptions"
							:key="opt.value"
							type="button"
							:class="{ 'is-active': selectedWeekdays.includes(opt.value) }"
							@click="toggleWeekday(opt.value)"
						>{{ opt.label }}</button>
					</div>
				</div>
			</div>

			<!-- TIME -->
			<div class="list__item drilldown">
				<div class="list__item__icon">
					<img src="@/assets/ic_24_fitnessplan_time.svg" alt="" />
				</div>
				<div class="list__item__content">
					<div class="list__item__label">
						Uhrzeit
					</div>
					<div class="list__item__value list__item__value--light">
						<input type="time" v-model="activityTime" style="width: 100%">
					</div>
                </div>
			</div>

		</div>

		<!-- NOTES -->
		<div class="list list--background">
			<div class="fitnessplanCreate__notes">
				<div class="list__item__label">
					Hinweise / Notizen
				</div>
				<textarea
					v-model="notes"
					class="fitnessplanCreate__notes-input"
					rows="3"
					placeholder="Hast Du Hinweise, Notizen oder Anmerkungen zu diesem Training?"
				></textarea>
			</div>
		</div>

		<v-btn :disabled="!selectedFitnessPlanActivity" @click="finaliseEvent" class="button button--primary">{{ finaliseButtonTitle }}</v-btn>
	</div>
</template>

<script>
import moment from "moment";
import RadioSet from "@/components/RadioSet";
import WorkoutItem from "@/components/WorkoutItem.vue";
import PlaylistItem from '@/components/PlaylistItem.vue';
import TrackedWorkoutsModal from "@/components/TrackedWorkoutsModal.vue";
import VueLoading from 'vue-loading-overlay/dist/vue-loading';
import { analytics } from '@/firebase/index.js';
import {
	addFitnessPlanEvent as apiAddEvent,
	updateFitnessPlanEvent as apiUpdateEvent,
	addEventException as apiAddException,
	updateEventStatus,
} from '@/services/fitnessPlanApi';
import { buildMetricsFromWorkout } from '@/utils/workoutMetrics';

const WEEKDAY_OPTIONS = [
	{ value: 0, label: 'Mo' },
	{ value: 1, label: 'Di' },
	{ value: 2, label: 'Mi' },
	{ value: 3, label: 'Do' },
	{ value: 4, label: 'Fr' },
	{ value: 5, label: 'Sa' },
	{ value: 6, label: 'So' },
];

const REPEAT_TO_FREQUENCY = { 0: 'weekly', 1: 'biweekly', 2: 'monthly' };
const FREQUENCY_TO_REPEAT = { weekly: 0, biweekly: 1, monthly: 2 };

/** ISO date (YYYY-MM-DD) → Mo=0 … So=6 */
function weekdayFromDate(dateStr) {
	if (!dateStr) return 0;
	return (new Date(dateStr + 'T12:00:00').getDay() + 6) % 7;
}

export default {
	name: 'FitnessplanCreate',
	components: { RadioSet, WorkoutItem, PlaylistItem, TrackedWorkoutsModal, VueLoading },
	data() {
		return {
			repeatActivity: false,
			//weekday: 1,
			repeatOptions: [
                { key: "Jede Woche", value: 0 },
				{ key: "Jede 2. Woche", value: 1 },
				{ key: "Monatlich", value: 2 },
			],
			weekdayOptions: WEEKDAY_OPTIONS,
			selectedWeekdays: [0],
			selectedRepeatInterval: null,
			activityDate: null,
			activityEndDate: null,
			activityTime: "18:00",
			notes: "",
			// fitnessPlan: { items: [] }, // ENTFERNT: Wird nicht verwendet (Performance-Optimierung)
			editItemId: null,
            relatedFitnessPlanItem: null,
            uniqueChallengeId: null,
			showLoadingIndicator: false,
		}
	},
	methods: {
		resolveRepeatOption(intervalRaw, frequencyRaw) {
			const fromInterval = Number(intervalRaw);
			if (Number.isInteger(fromInterval) && fromInterval >= 0 && fromInterval <= 2) {
				return this.repeatOptions[fromInterval];
			}
			const fromFrequency = FREQUENCY_TO_REPEAT[frequencyRaw];
			if (fromFrequency !== undefined) {
				return this.repeatOptions[fromFrequency];
			}
			return this.repeatOptions[0];
		},
		toggleWeekday(value) {
			const idx = this.selectedWeekdays.indexOf(value);
			if (idx >= 0) {
				if (this.selectedWeekdays.length <= 1) return;
				this.selectedWeekdays.splice(idx, 1);
			} else {
				this.selectedWeekdays.push(value);
				this.selectedWeekdays.sort((a, b) => a - b);
			}
		},
		loadSelectedWeekdays() {
			const raw = window.localStorage.getItem('selectedWeekdays');
			if (raw) {
				try {
					const parsed = JSON.parse(raw);
					if (Array.isArray(parsed) && parsed.length > 0) {
						this.selectedWeekdays = parsed.map(Number).filter((n) => n >= 0 && n <= 6);
						if (this.selectedWeekdays.length > 0) return;
					}
				} catch (e) { /* fall through */ }
			}
			this.selectedWeekdays = [weekdayFromDate(this.activityDate)];
		},
		init() {
			this.editItemId = this.$route.query.guid;

            this.relatedFitnessPlanItem = this.$route.query.related_guid;

			/*this.$store.dispatch('fetchFitnessPlan').then( (res) => {
				if (res.length != 0) {
					this.fitnessPlan = res[0];
				}
			});*/
            // DEAKTIVIERT: this.fitnessPlan = this.$store.getters.getFitnessplan;
            // → Nicht benötigt für Event-Erstellung/Challenge-Cancel (Performance-Optimierung)

			this.activityDate = window.localStorage.getItem('activityDate') || this.$route.query.initialDate || new Date().toISOString().split('T')[0];
			this.loadSelectedWeekdays();
			this.activityEndDate = window.localStorage.getItem('activityEndDate');
			this.activityTime = window.localStorage.getItem('activityTime') || "18:00";
			this.selectedRepeatInterval = this.resolveRepeatOption(
				window.localStorage.getItem('selectedRepeatInterval'),
				window.localStorage.getItem('selectedFrequency'),
			);
            if (window.localStorage.getItem('uniqueChallengeId')) {
                this.uniqueChallengeId = window.localStorage.getItem('uniqueChallengeId');
                window.localStorage.removeItem('uniqueChallengeId');
            }
			this.notes = window.localStorage.getItem('activityNotes') || "";
			// Fresh create always starts with Serientermin off. Only restore when editing a series.
			if (this.editItemId && window.localStorage.getItem('repeatActivity') === 'true') {
				this.repeatActivity = true;
			} else if (!this.editItemId) {
				this.repeatActivity = false;
			}
		},
		selectActivity() {
			this.$router.push("/fitnessplan/create/exercises");
		},
		openTrackedWorkoutsModal() {
			this.$modal.show("trackedWorkouts");
			analytics.logEvent('try_import_of_tracking_data');
		},
		closeTrackedWorkoutsModal() {
			this.$modal.hide("trackedWorkouts");
		},
		async resolveSportsTypeActivity(workoutTypeLabel) {
			const label = (workoutTypeLabel || "").trim() || "Individuelles Workout";
			await this.$store.dispatch('fetchSportsTypes');
			const catalog = this.$store.getters.getSportsTypes || [];
			let match = catalog.find((st) => st.name === label);
			if (!match) {
				try {
					const res = await this.$store.dispatch('fetchUserInformation');
					const userInfo = res && res[0];
					const customs = (userInfo && userInfo.customSportsTypes) || [];
					const customIdx = customs.findIndex((name) => name === label);
					if (customIdx >= 0) {
						match = {
							name: customs[customIdx],
							id: 10000 + customIdx,
							image_url: "fitness.jpg",
						};
					}
				} catch (e) {
					/* fall through to synthetic */
				}
			}
			if (!match) {
				match = {
					name: label,
					id: 10000 + label.length,
					image_url: "fitness.jpg",
				};
			}
			return Object.assign({}, match, { meta: { type: "Custom/SportsType" } });
		},
		async importWorkout(workout) {
			this.closeTrackedWorkoutsModal();
			this.showLoadingIndicator = true;

			const userId = this.$store.state.user?.user?.uid;
			if (!userId) {
				this.showLoadingIndicator = false;
				alert('Fehler: Benutzer nicht eingeloggt');
				return;
			}

			try {
				const activityDate = moment(workout.from_utc.split(" ")[0], 'YYYY-MM-DD').format('YYYY-MM-DD');
				const activityTime = moment(workout.from_utc.split(" ")[1], 'HH:mm').format('HH:mm');
				const distanceKm = Math.round((workout.distance?.value || 0) / 10) / 100;
				const activity = await this.resolveSportsTypeActivity(workout.type);

				const addResult = await apiAddEvent(userId, {
					repeating: false,
					activityTime,
					activityDate,
					activity,
					notes: null,
				});

				const guid = (addResult.event && addResult.event.guid) || addResult.guid;
				if (!guid) {
					throw new Error('Event wurde angelegt, aber keine GUID zurückgegeben');
				}

				const eventInfo = {
					guid,
					activityDate,
					activityTime,
					status: 'finished',
					activity,
				};
				const extraData = {
					realDuration: workout.duration / 60,
					energyExpended: workout.energy?.value || 0,
					distance: distanceKm,
					trackedWorkoutFrom: workout.import_source,
					_realStartDate: moment(activityDate + ' ' + activityTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm'),
				};
				const metrics = buildMetricsFromWorkout(workout, {
					distanceKm,
					durationSeconds: workout.duration,
				});
				if (metrics) {
					extraData.metrics = metrics;
				}

				await updateEventStatus(userId, eventInfo, extraData);

				this.$store.commit('addRecentFitnessPlanActivity', Object.assign({}, activity));
				this.$store.state.fitnessPlan = null;
				this.clearLocalStorage();
				this.showLoadingIndicator = false;
				this.$router.go(-1);
			} catch (error) {
				console.error('Error importing workout as new training:', error);
				this.showLoadingIndicator = false;
				alert('Fehler beim Importieren des Trainings: ' + (error.message || 'Unbekannter Fehler'));
			}
		},
		async finaliseEvent() {
			this.showLoadingIndicator = true;
			this.$store.commit('addRecentFitnessPlanActivity', Object.assign({}, this.selectedFitnessPlanActivity));
			
			const userId = this.$store.state.user?.user?.uid;
			if (!userId) {
				this.showLoadingIndicator = false;
				alert('Fehler: Benutzer nicht eingeloggt');
				return;
			}

			try {
				if (this.editItemId) {
					// Event bearbeiten - Optimierte Server-API
					await this.updateFitnessPlanEvent(userId, this.editItemId);
				} else {
					// Exception Date hinzufügen (falls nötig)
					if(this.relatedFitnessPlanItem) {
						const originalDate = window.localStorage.getItem('originalActivityDate');
						await this.addEventException(userId, this.relatedFitnessPlanItem, originalDate);
					}
					
					// Neues Event hinzufügen - Optimierte Server-API
					await this.addFitnessPlanEvent(userId);
				}

				this.showLoadingIndicator = false;
				this.$router.go(-1);

			} catch (error) {
				console.error('Error finalizing event:', error);
				this.showLoadingIndicator = false;
				alert('Fehler beim Speichern des Events: ' + error.message);
			}
		},

		buildEventPayload() {
			const payload = {
				repeating: !!this.repeatActivity,
				activityTime: this.activityTime,
				activityDate: this.activityDate,
				activity: Object.assign({}, this.selectedFitnessPlanActivity),
			};
			const trimmedNotes = (this.notes || "").trim();
			payload.notes = trimmedNotes || null;
			if (!this.repeatActivity) {
				return payload;
			}
			const interval = this.selectedRepeatInterval ? this.selectedRepeatInterval.value : 0;
			// FitPlus/CoachPlus weekdays are Mon=0. Multi-select from the weekday picker.
			const weekdays = interval === 2
				? []
				: [...this.selectedWeekdays].sort((a, b) => a - b);
			payload.repeatInterval = interval;
			payload.frequency = REPEAT_TO_FREQUENCY[interval] || 'weekly';
			payload.weekdays = weekdays;
			// Legacy Cloud Functions expect JS getDay() (Sun=0). FitPlus uses
			// `weekdays` (Mon=0) and ignores this when weekdays is non-empty.
			payload.weekday = weekdays.length === 1
				? (weekdays[0] + 1) % 7
				: null;
			payload.activityEndDate = this.activityEndDate;
			return payload;
		},
		async addFitnessPlanEvent(userId) {
			return apiAddEvent(userId, this.buildEventPayload());
		},
		async updateFitnessPlanEvent(userId, eventId) {
			return apiUpdateEvent(userId, eventId, this.buildEventPayload());
		},
		async addEventException(userId, eventId, exceptionDate) {
			return apiAddException(userId, eventId, exceptionDate);
		},
		clearLocalStorage() {
			this.$store.commit('setSelectedFitnessPlanActivity', null);
			window.localStorage.removeItem('activityDate');
			window.localStorage.removeItem('activityEndDate');
			window.localStorage.removeItem('activityTime');
			window.localStorage.removeItem('selectedRepeatInterval');
			window.localStorage.removeItem('selectedFrequency');
			window.localStorage.removeItem('selectedWeekdays');
			window.localStorage.removeItem('repeatActivity');
			window.localStorage.removeItem('activityNotes');
		}
	},
	computed: {
		showImportSection() {
			return !this.editItemId && !this.relatedFitnessPlanItem && !this.uniqueChallengeId;
		},
		selectedFitnessPlanActivity() {
			return this.$store.getters.getSelectedFitnessPlanActivity;
		},
		activityType() {
			if (this.selectedFitnessPlanActivity == null) { return null; }
			if (this.selectedFitnessPlanActivity.meta === undefined) { return "Category"; }
			else { return this.selectedFitnessPlanActivity.meta.type; }
		},
		finaliseButtonTitle() {
			if (this.editItemId) { return "Änderungen speichern"; }
			return "Training erstellen";
		}
    },
	mounted() {
		this.init();
	},
	/* eslint-disable no-unused-vars */
	beforeRouteLeave (to, from, next) {
		// called when the route that renders this component is about to
		// be navigated away from.
		// has access to `this` component instance.

		if (to.path == "/fitnessplan/create/exercises") {
			// persist vars to localstorage
			window.localStorage.setItem('activityDate', this.activityDate);
			if (this.activityEndDate) {
				window.localStorage.setItem('activityEndDate', this.activityEndDate);
			}
			window.localStorage.setItem('activityTime', this.activityTime);
			window.localStorage.setItem('activityNotes', this.notes || '');
			window.localStorage.setItem('selectedRepeatInterval', this.selectedRepeatInterval.value);
			window.localStorage.setItem('selectedWeekdays', JSON.stringify(this.selectedWeekdays));
			window.localStorage.setItem('repeatActivity', this.repeatActivity);
		}
		else {
			this.clearLocalStorage();
		}
		next();
	}
}
</script>

<style lang="scss">
	.fitnessplanCreate {
		display: flex;
		flex-direction: column;
		min-height: 100%;

		> .button--primary {
			margin-top: auto;
		}

		&__import {
			margin-bottom: 0;
		}

		&__notes {
			display: flex;
			flex-direction: column;
			align-items: stretch;
			gap: 8px;
			padding: 12px 0 16px;

			.list__item__label {
				margin-bottom: 0;
			}
		}

		&__notes-input {
			display: block;
			width: 100%;
			min-height: 72px;
			padding: 12px !important;
			margin-bottom: 0;
			border: 0;
			border-radius: 8px;
			background: rgba($colorBlack, .04);
			font-size: 16px;
			line-height: 1.4;
			font-weight: 400;
			color: $colorBlack;
			text-align: left;
			resize: vertical;
			box-sizing: border-box;

			&::placeholder {
				color: rgba($colorBlack, .32);
			}
		}

		&__exercise {
			display: flex;
			flex-direction: column;
			background: rgba($colorBlack, .04);
			border-radius: 8px;
			overflow: hidden;
			margin-bottom: 16px;

			&--empty {
				font-size: 14px;
				font-weight: 700;
				letter-spacing: -0.21px;
				color: rgba($colorBlack, .24);
				text-transform: uppercase;
				padding: 64px 0 48px;
				text-align: center;
				align-items: center;
				justify-content: center;

				img {
					opacity: .24;
					margin-bottom: 11px;
				}
			}

			&__item {
				width: 100%;

				.card, .workout__item {
					border-radius: 4px 4px 0 0;
					margin-bottom: 0!important;
				}
			}

			&__footer {
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 14px;
				line-height: 20px;
				font-weight: 700;
				letter-spacing: -0.21px;
				background: $colorPrimary;
				color: $colorWhite;
				padding: 12px 0;

				img {
					margin-right: 6px;
				}
			}
		}

		&__serie {
			div {
				display: flex;
				justify-content: space-between;
				margin-top: -8px;
			}

			button {
				font-size: 11px;
				font-weight: 700;
				letter-spacing: -0.23px;
				background: rgba($colorBlack, .08);
				color: rgba($colorBlack, .48);
				border-radius: 2px;
				padding: 6px 0;
				transition: all .2s ease-in-out;
				flex: auto;
				margin: 0 12px !important;

				&:first-of-type, &:last-of-type {
					margin: 0 !important;
				}

				&.is-active {
					box-shadow: inset 0 0 0 1px $colorPrimary, 0 0 0 1px $colorPrimary;
					background: rgba($colorPrimary, .24);
					color: $colorPrimary;
				}
			}
		}

		&__weekdaysRow {
			flex-direction: column;
			align-items: stretch;
		}

		&__weekdays {
			display: flex;
			justify-content: space-between;
			margin-top: 8px;
			width: 100%;

			button {
				font-size: 11px;
				font-weight: 700;
				letter-spacing: -0.23px;
				background: rgba($colorBlack, .08);
				color: rgba($colorBlack, .48);
				border: none;
				border-radius: 2px;
				padding: 6px 0;
				transition: all .2s ease-in-out;
				flex: 1;
				margin: 0 3px;
				cursor: pointer;

				&:first-of-type {
					margin-left: 0;
				}

				&:last-of-type {
					margin-right: 0;
				}

				&.is-active {
					box-shadow: inset 0 0 0 1px $colorPrimary, 0 0 0 1px $colorPrimary;
					background: rgba($colorPrimary, .24);
					color: $colorPrimary;
				}
			}
		}

		.is-active {
			box-shadow: none;
		}

		.list {
			margin-bottom: 16px;

			&__item__label {
				font-size: 17px;
			}

			input[type="date"], input[type="time"], select {
				min-height: inherit;
				color: rgba($colorBlack, .48);
				font-size: 14px;
				line-height: 20px;
				opacity: 1;
				text-align: right;
				display: flex;
				justify-content: center;

				&::-webkit-input-placeholder, ::-moz-placeholder, :-ms-input-placeholder, :-moz-placeholder {
					color: rgba($colorBlack, .48);
				}

				&::-webkit-date-and-time-value{
					margin-right: 0 !important;
				}
			}

			input[type="time"] {
				&:after {
					content: 'Uhr';
					margin-left: 4px;
				}
			}
		}
	}
</style>